module.exports = __webpack_public_path__ + "media/images/noticias/viejas/biopsia/equipo_biopsia-2a88803604d40c7d46136b8778aa4c8a.jpg";